/**
 * Utility functions for sensor calculations
 */

/**
 * Calculate the number of OA sensors needed based on area, coverage, and ceiling height
 * 
 * @param {number} areaInSquareMeters - Area in square meters
 * @param {number} coverageInSquareFeet - Coverage per sensor in square feet
 * @param {number} metersToFeetConversion - Conversion factor from meters to feet (default: 3.28084)
 * @param {number} ceilingHeightFeet - Ceiling height in feet (default: 9.0)
 * @returns {number} Number of sensors needed (rounded up)
 */
export const calculateOASensors = (
  areaInSquareMeters, 
  coverageInSquareFeet, 
  metersToFeetConversion = 3.28084,
  ceilingHeightFeet = 9.0
) => {
  // Convert area from square meters to square feet
  const areaInSquareFeet = areaInSquareMeters * metersToFeetConversion * metersToFeetConversion;
  
  // Apply ceiling height factor if higher than standard (9ft)
  // For every foot above 9ft, increase sensor count by 5%
  const ceilingFactor = ceilingHeightFeet > 9.0 
    ? 1.0 + (0.05 * (ceilingHeightFeet - 9.0)) 
    : 1.0;
  
  // Calculate number of sensors needed with ceiling factor (rounded up)
  return Math.max(1, Math.ceil((areaInSquareFeet / coverageInSquareFeet) * ceilingFactor));
}; 